import React from "react";
import { TextField } from "@syos-music/form";

import { Stack } from "@mui/material";

const FLAGS = {
  en: "🇬🇧",
  fr: "🇫🇷",
  ja: "🇯🇵",
};

export default function IntlTextField({ name, label, locales, ...props }) {
  return (
    <Stack spacing={2} direction="row">
      {locales.map((locale) => (
        <TextField
          key={locale}
          name={`${name}.${locale}`}
          label={label && `${FLAGS[locale]} ${label}`}
          {...props}
        />
      ))}
    </Stack>
  );
}

IntlTextField.defaultProps = {
  locales: ["en", "fr"],
};
